import GridColumnProps from './Columns'

let KendoGridColumn = {
    name: 'kendo-grid-column',
    render () {
        return null
    },
    mixins: [GridColumnProps]
}

export default KendoGridColumn


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridColumn/index.js